/*-----------------------------------------------------------------
- Content fields
-----------------------------------------------------------------*/
export default {};
